import { APICore, PENSION_URL, PENSION_ZOON_URL } from './apiCore';
import { NewPensionProduct } from '../../interfaces/NewPensionProduct';
import { InventoryProductsFetchParams, PensionProduct } from '../../interfaces/PensionProduct';
import { Pension } from '../../interfaces/Pension';
import { PensionProductCommissionsFetchParams } from '../../interfaces/PensionProductCommissions';

const api = new APICore();

const getProducts = (params: { pensionId?: string; productId?: string }) => {
    const relativeUrl = '/products';
    return api.get(`${PENSION_URL}${relativeUrl}`, params);
};

const getProduct = (productId: string) => {
    const relativeUrl = '/products/' + productId;
    return api.get(`${PENSION_URL}${relativeUrl}`);
};

const updateProduct = (productId: string, update: any) => {
    const relativeUrl = '/products/' + productId;
    return api.update(`${PENSION_URL}${relativeUrl}`, update);
};

const removeProduct = (productId: string) => {
    const relativeUrl = '/products/' + productId;
    return api.delete(`${PENSION_URL}${relativeUrl}`);
};

const getNewProductData = (isPensionRound: boolean = true) => {
    const relativeUrl = '/products/new-product-data';
    return api.get(`${PENSION_URL}${relativeUrl}`, { isPensionRound });
};

const createProduct = (newProduct: NewPensionProduct) => {
    const relativeUrl = '/products';
    return api.create(`${PENSION_URL}${relativeUrl}`, newProduct);
};

const getDeposits = (params: { pensionId: string }) => {
    const relativeUrl = '/products/deposits';
    return api.get(`${PENSION_URL}${relativeUrl}`, params);
};

const simulateCommissions = (productId: string, params: { savingsCommission: number; depositCommission: number }[]) => {
    const relativeUrl = `/products/${productId}/simulate`;
    const newParams: any = params.reduce((acc, curr) => {
        acc += `simulations[]=${encodeURIComponent(JSON.stringify(curr))}`;
        acc += '&';
        return acc;
    }, '');
    return api.get(`${PENSION_URL}${relativeUrl}`, newParams);
};

const getSimulatedCommissionsDocFile = (productId: string, params: any) => {
    const relativeUrl = `/products/${productId}/download-simulation-doc`;
    return api.getFile(`${PENSION_URL}${relativeUrl}`, params);
};

const getActionableProducts = (params: { page: number | undefined }) => {
    const relativeUrl = '/products/actionable';
    return api.get(`${PENSION_URL}${relativeUrl}`, params);
};

const getDiscountForm = (productId: string) => {
    const relativeUrl = `/products/${productId}/discount-doc`;
    return api.getFile(`${PENSION_URL}${relativeUrl}`);
};

const addComment = (productId: string, comment: string) => {
    const relativeUrl = `/products/${productId}/comment`;
    return api.create(`${PENSION_URL}${relativeUrl}`, { comment });
};

const submitB2 = (productId: string) => {
    const relativeUrl = `/products/${productId}/submitB2Form`;
    return api.create(`${PENSION_URL}${relativeUrl}`, {});
};

const updateProducts = (clientId: string, pensionId: string) => {
    const relativeUrl = `/pension-zoom/update/?clientId=${clientId}&pensionId=${pensionId}`;
    return api.create(`${PENSION_ZOON_URL}${relativeUrl}`, {});
};

const getProductsForPensionZoom = (pensionId: string) => {
    const relativeUrl = `/pension-zoom/products?pensionId=${pensionId}`;
    return api.get(`${PENSION_ZOON_URL}${relativeUrl}`);
};

const getInventoryProducts = (params?: InventoryProductsFetchParams) => {
    const relativeUrl = '/inventory-products';
    return api.get(`${PENSION_URL}${relativeUrl}`, params);
};

const getCommissionsData = (params?: PensionProductCommissionsFetchParams) => {
    const relativeUrl = '/pension/commissions';
    return api.get(`${PENSION_URL}${relativeUrl}`, params);
};

const getInventoryProductsFile = (params?: InventoryProductsFetchParams) => {
    const relativeUrl = '/inventory-products/download';
    return api.getFile(`${PENSION_URL}${relativeUrl}`, params);
};

export {
    removeProduct,
    createProduct,
    getNewProductData,
    addComment,
    getDeposits,
    getDiscountForm,
    getProducts,
    updateProduct,
    getProduct,
    getActionableProducts,
    simulateCommissions,
    submitB2,
    updateProducts,
    getProductsForPensionZoom,
    getInventoryProducts,
    getCommissionsData,
    getInventoryProductsFile,
    getSimulatedCommissionsDocFile,
};
